// extracted by mini-css-extract-plugin
var _1 = "TutorialProgress-module__active--kFKLr";
var _2 = "TutorialProgress-module__dot--uv2vX";
var _3 = "TutorialProgress-module__dots--jHcCG";
export { _1 as "active", _2 as "dot", _3 as "dots" }
